import type { LocalisedContactInfo } from '@seek/adv-header-footer';
import type { Locale } from '@seek/melways-sites';
import gql from 'graphql-tag';

import getClient from 'src/modules/ApiClient/hirerGraph/apiClient';

export const query = gql`
  query GetLocalisedContactInfo($locale: String!) {
    localisedContactInfo(locale: $locale) {
      contactUsLink
      businessHours
      contactNumber
      helpCentreLink
    }
  }
`;

export type GetLocalisedContactInfo = (locale?: Locale) => Promise<{
  localisedContactInfo: LocalisedContactInfo;
}>;

const getLocalisedContactInfo: GetLocalisedContactInfo = async (locale) => {
  const graphqlClient = getClient();
  const result = await graphqlClient.query<{
    localisedContactInfo: LocalisedContactInfo;
  }>({
    variables: { locale },
    query,
  });

  return { localisedContactInfo: result.data.localisedContactInfo };
};

export default getLocalisedContactInfo;
